import React, { useEffect } from "react";
import Navbar from "../../component/Navbar/Navbar";
import PricingSection from "./PricingSection";
import FAQ from "../../component/Faqs/FAQ";
import Banner from "./Banner";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import Footer from "../../component/Footer/Footer";

const Pricing = () => {
  const location = useLocation();

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const redirectStatus = query.get("redirect_status");

    // Shared toastId so the same toast never stacks (StrictMode double-invoke
    // or the effect re-running while redirect_status stays in the URL).
    const opts = { toastId: `pay-${redirectStatus}` };
    if (redirectStatus === "succeeded") {
      toast.success("Payment successful! 🎉", opts);
    } else if (redirectStatus === "failed") {
      toast.error("Payment failed. Please try again.", opts);
    } else if (redirectStatus === "canceled") {
      toast.info("Payment was canceled.", opts);
    }
  }, [location]);
  return (
    <>
      <div className="bg-white md:p-4 p-3 max-w-screen-2xl mx-auto flex flex-col xl:gap-20 lg:gap-16 gap-12 pb-10  leading-tight ">
        <Navbar />
        <div className="relative  overflow-hidden rounded-t-2xl mt-6 md:mt-0">
          <div className="absolute top-0 left-0 w-full h-full hidden md:flex flex-col z-0">
            <div className="relative flex-[2] bg-gradient-to-t from-[#3AB1F6] via-[#3AB1F626] to-[#D8EFFD] rounded-2xl">
              <svg
                className="absolute top-0 left-0 w-full h-full  rounded-2xl z-[4]"
                viewBox="0 0 1000 1350"
                preserveAspectRatio="none"
              >
                <path
                  id="orbitPath"
                  d="
        M40,0 
        H960 
        A40,40 0 0 1 1000,40 
        V1310 
        A40,40 0 0 1 960,1350 
        H40 
        A40,40 0 0 1 0,1310 
        V40 
        A40,40 0 0 1 40,0 
        Z"
                  fill="none"
                  stroke="transparent"
                />

                {/* Orbiting Glow Circle */}
                <circle r="300" fill="url(#glow)" filter="url(#blur)">
                  <animateMotion
                    repeatCount="indefinite"
                    dur="20s"
                    rotate="auto"
                  >
                    <mpath href="#orbitPath" />
                  </animateMotion>
                </circle>

                <circle r="300" fill="url(#glow)" filter="url(#blur)">
                  <animateMotion
                    repeatCount="indefinite"
                    dur="20s"
                    rotate="auto"
                    keyPoints="1;0"
                    keyTimes="0;1"
                  >
                    <mpath href="#orbitPath" />
                  </animateMotion>
                </circle>

                {/* Gradient Glow */}
                <defs>
                  <radialGradient id="glow" cx="50%" cy="50%" r="50%">
                    <stop offset="0%" stopColor="#3AB1F6" stopOpacity=".9" />
                    <stop offset="100%" stopColor="#3AB1F6" stopOpacity="0" />
                  </radialGradient>
                </defs>
                <filter
                  id="blur"
                  x="-100%"
                  y="-100%"
                  width="300%"
                  height="300%"
                >
                  <feGaussianBlur in="SourceGraphic" stdDeviation="20" />
                </filter>
              </svg>
            </div>

            <div className="flex-[1] bg-transparent" />
          </div>

          <div className=" flex flex-col gap-12 md:pt-36 pt-20 md:pb-16 pb-10 md:px-10 p-2 z-10 relative ">
            <div className="flex flex-col xl:gap-6 lg:gap-5 gap-4 mb-4">
              <div className=" flex justify-center items-center text-[.9rem] font-inter font-medium rounded-full text-[#3AB1F6] md:border border-[#3AB1F6] md:bg-transparent bg-[#EBF7FE] w-max mx-auto py-3 px-6">
                Flexible Plans. Powerful Conversations.
              </div>
              <div className="xl:text-[3.125rem] lg:text-[2.8rem] md:text-[2.4rem] text-[2.625rem] tracking-[-0.06em] leading-tight font-bold flex flex-col items-center text-center  font-jakarta ">
                <span className="md:flex hidden">Type with Your Voice.</span>
                <span className="md:flex hidden">Anywhere.</span>
                <span className="md:hidden flex">
                  Type with Your Voice. Anywhere
                </span>
              </div>
              <div className=" text-center xl:text-[1.438rem] lg:text-[1.2rem] md:text-[1.15rem] text-[1.313rem] font-medium font-inter text-[#00000099]">
                <span>
                  Save hours every week by ditching the keyboard. Dictate,
                  <br className="hidden md:flex" /> refine, and insert text in
                  any app with ZeroTyping.
                </span>
              </div>
              <div className=" w-max mx-auto text-[#00000099] xl:text-[2.1875rem] lg:text-[2.05rem] md:text-[1.9rem] text-[1.875rem]  font-justMe">
                Choose the plan that’s right for you.
              </div>
            </div>

            <PricingSection />
          </div>
        </div>
        <FAQ />
        <Banner />
      </div>
      <Footer />
    </>
  );
};

export default Pricing;
